import Div from "@jumbo/shared/Div";
import PermMediaIcon from "@mui/icons-material/PermMedia";
import {
  Autocomplete,
  Box,
  Button,
  TextField,
  Typography
} from "@mui/material";
import AllApis from "app/Apis/apis";
import Heading from "app/pages/Component/Heading";
import AddressTypeDialog from "app/pages/Masters/Suppliers/AutoAddAddress";
import { getRolesList } from "app/redux/actions/Roles";
import { getUsers } from "app/redux/actions/User";
import { City, Country, State } from "country-state-city";
import { Form, Formik } from "formik";
import { Axios } from "index";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import * as yup from "yup";
const AddEditUsers = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { state, pathname } = useLocation();
  // useSelector
  const { district, location, area, taluka } = useSelector(
    (state) => state?.addressDropdown
  );
  const { allroles } = useSelector((state) => state.roleReducer);
  const { user } = useSelector((state) => state?.userReducer);
  //  useState
  const [isSubmitting, setSubmitting] = useState(false);
  const [headingName, setHeadingName] = useState(
    pathname.split("/").pop() == "add" ? "Add New User" : "Edit User"
  );
  const [imageURL, setImageURL] = useState({
    profile_pic: "",
    aadhar_image: "",
    pan_image: "",
    passbook_image: "",
  });

  const [stateCityList, setStateCityList] = useState({
    stateList: State.getStatesOfCountry("IN"),
    cityList: City.getCitiesOfState("IN", "MH"),
    countryList: Country.getCountryByCode("IN"),
  });

  const handleImagesTab = async (value) => {
    if (value && typeof value === "string") {
      const imageURL = new URL(`${process.env.REACT_APP_IMAGE_URL}/${value}`);
      window.open(imageURL.href, "_blank");
    } else {
      const images = URL.createObjectURL(value);
      window.open(images, "__blank");
    }
  };
  const InitialValues = {
    employee_id: state?.current_data?.employee_id
      ? state?.current_data?.employee_id
      : "",
    first_name: state?.current_data?.first_name
      ? state?.current_data?.first_name
      : "",
    last_name: state?.current_data?.last_name
      ? state?.current_data?.last_name
      : "",
    primary_email_id: state?.current_data?.primary_email_id
      ? state?.current_data?.primary_email_id
      : "",
    secondary_email_id: state?.current_data?.secondary_email_id
      ? state?.current_data?.secondary_email_id
      : "",
    primary_mobile_no: state?.current_data?.primary_mobile_no
      ? state?.current_data?.primary_mobile_no
      : "",
    secondary_mobile_no: state?.current_data?.secondary_mobile_no
      ? state?.current_data?.secondary_mobile_no
      : "",
    profile_pic: state?.current_data?.profile_pic
      ? state?.current_data?.profile_pic
      : "",
    roles: {
      role_id: state?.current_data?.role_id?._id
        ? state?.current_data?.role_id?._id
        : "",
      role_name: state?.current_data?.role_id?.current_data?.role_name
        ? state?.current_data?.role_id?.current_data?.role_name
        : "",
    },
    status: state?.current_data?.status ? state?.current_data?.status : "",
    isActive: state?.current_data?.isActive
      ? state?.current_data?.isActive
      : "",
    password: state?.current_data?.password
      ? state?.current_data?.password
      : "",
    address: {
      address: state?.current_data?.address.address
        ? state?.current_data?.address.address
        : "",
      location: state?.current_data?.address.location
        ? state?.current_data?.address.location
        : "",
      area: state?.current_data?.address.area
        ? state?.current_data?.address.area
        : "",
      district: state?.current_data?.address.district
        ? state?.current_data?.address.district
        : "",
      taluka: state?.current_data?.address.taluka
        ? state?.current_data?.address.taluka
        : "",
      state: state?.current_data?.address.state
        ? state?.current_data?.address?.state
        : "",
      city: state?.current_data?.address?.city
        ? state?.current_data?.address?.city
        : "",
      country: state?.current_data?.address?.country
        ? state?.current_data?.address?.country
        : "",
      pincode: state?.current_data?.address?.pincode
        ? state?.current_data?.address?.pincode
        : "",
    },
    kyc: {
      pan_card_detail: {
        pan_no: state?.current_data?.kyc?.pan_card_detail.pan_no
          ? state?.current_data?.kyc?.pan_card_detail.pan_no
          : "",
        pan_image: state?.current_data?.kyc?.pan_card_detail.pan_image
          ? state?.current_data?.kyc?.pan_card_detail.pan_image
          : "",
      },
      aadhar_card_detail: {
        aadhar_no: state?.current_data?.kyc?.aadhar_card_detail?.aadhar_no
          ? state?.current_data?.kyc?.aadhar_card_detail?.aadhar_no
          : "",
        aadhar_image: state?.current_data?.kyc?.aadhar_card_detail?.aadhar_image
          ? state?.current_data?.kyc?.aadhar_card_detail?.aadhar_image
          : "",
      },
      bank_details: {
        bank_name: state?.current_data?.kyc?.bank_details?.bank_name
          ? state?.current_data?.kyc?.bank_details?.bank_name
          : "",
        account_no: state?.current_data?.kyc?.bank_details?.account_no
          ? state?.current_data?.kyc?.bank_details?.account_no
          : "",
        confirm_account_no: state?.current_data?.kyc?.bank_details
          ?.confirm_account_no
          ? state?.current_data?.kyc?.bank_details?.confirm_account_no
          : "",
        ifsc_code: state?.current_data?.kyc?.bank_details?.ifsc_code
          ? state?.current_data?.kyc?.bank_details?.ifsc_code
          : "",
        passbook_image: state?.current_data?.kyc?.bank_details?.passbook_image
          ? state?.current_data?.kyc?.bank_details?.passbook_image
          : "",
      },
    },
    approvers: {
      approver1: {
        name: state?.current_data?.approver_one?.name
          ? state?.current_data?.approver_one?.name
          : "",
        email_id: state?.current_data?.approver_one?.email_id
          ? state?.current_data?.approver_one?.email_id
          : "",
        user_id: state?.current_data?.approver_one?.user_id
          ? state?.current_data?.approver_one?.user_id
          : "",
        employee_id: state?.current_data?.approver_one?.employee_id
          ? state?.current_data?.approver_one?.employee_id
          : "",
      },
      approver2: {
        name: state?.current_data?.approver_two?.name
          ? state?.current_data?.approver_two?.name
          : "",
        email_id: state?.current_data?.approver_two?.email_id
          ? state?.current_data?.approver_two?.email_id
          : "",
        user_id: state?.current_data?.approver_two?.user_id
          ? state?.current_data?.approver_two?.user_id
          : "",
        employee_id: state?.current_data?.approver_two?.employee_id
          ? state?.current_data?.approver_one?.employee_id
          : "",
      },
    },
    created_by: {
      user_id: "",
      name: "",
      email_id: "",
      employee_id: "",
    },
  };
  const handleSubmit = async (values) => {
    let formdata = new FormData();
    let response;
    try {
      setSubmitting(true);
      if (pathname.split("/").pop() === "add") {
        formdata.append("employee_id", values.employee_id);
        formdata.append("first_name", values.first_name);
        formdata.append("last_name", values.last_name);
        formdata.append("primary_email_id", values.primary_email_id);
        values.secondary_email_id && formdata.append("secondary_email_id", values.secondary_email_id);
        formdata.append("password", values.password);
        formdata.append("primary_mobile_no", values.primary_mobile_no);
        values.secondary_mobile_no && formdata.append("secondary_mobile_no", values.secondary_mobile_no);
        formdata.append("profile_pic", values.profile_pic);
        formdata.append("role_id", values.roles.role_id);
        formdata.append(
          "aadhar_image",
          values.kyc.aadhar_card_detail.aadhar_image
        );
        formdata.append("pan_image", values.kyc.pan_card_detail.pan_image);
        formdata.append(
          "passbook_image",
          values.kyc.bank_details.passbook_image
        );
        formdata.append("address", JSON.stringify(values.address));
        formdata.append("kyc", JSON.stringify(values.kyc));
        formdata.append(
          "approver_one",
          JSON.stringify(values?.approvers?.approver1)
        );
        if (values?.approvers?.approver2?.name != "") {
          formdata.append(
            "approver_two",
            JSON.stringify(values?.approvers?.approver2)
          );
        }
        response = await Axios.post(AllApis.users.add, formdata);
      } else {
        // Assuming you have a valid 'state' object
        // console.log(values,"sdfsdfsfsfsf")
        // const updatedFields = getUpdatedFields(state.current_data, values);
        // console.log(updatedFields);
        // Object.entries(updatedFields).map((item) =>
        //   formdata.append(item[0], item[1])
        // );
        formdata.append("employee_id", values.employee_id);
        formdata.append("first_name", values.first_name);
        formdata.append("last_name", values.last_name);
        formdata.append("primary_email_id", values.primary_email_id);
        values.secondary_email_id && formdata.append("secondary_email_id", values.secondary_email_id);
        formdata.append("password", values.password);
        formdata.append("primary_mobile_no", values.primary_mobile_no);
        values.secondary_mobile_no && formdata.append("secondary_mobile_no", values.secondary_mobile_no);
        formdata.append("profile_pic", values.profile_pic);
        formdata.append("role_id", values.roles.role_id);
        formdata.append(
          "aadhar_image",
          values.kyc.aadhar_card_detail.aadhar_image
        );
        formdata.append("pan_image", values.kyc.pan_card_detail.pan_image);
        formdata.append(
          "passbook_image",
          values.kyc.bank_details.passbook_image
        );
        formdata.append("address", JSON.stringify(values.address));
        formdata.append("kyc", JSON.stringify(values.kyc));
        formdata.append(
          "approver_one",
          JSON.stringify(values?.approvers?.approver1)
        );
        if (values?.approvers?.approver2?.name != "") {
          formdata.append(
            "approver_two",
            JSON.stringify(values?.approvers?.approver2)
          );
        }
        // console.log(formdata);
        response = await Axios.patch(AllApis.users.edit(state._id), formdata);
      }
      if (response?.data?.statusCode) {
        Swal.fire({
          title:
            pathname.split("/").pop() === "add"
              ? "New User Added"
              : "User Updated",
          icon: "success",
          timer: 1000,
          showConfirmButton: false,
        });
        navigate("/dashboards/users");
      }
    } catch (error) {
      Swal.fire({
        title: error?.response?.data.message,
        icon: "error",
        timer: 1000,
        showConfirmButton: false,
      });
    } finally {
      setSubmitting(false);
    }
  };
  const validationSchema = yup.object().shape({
    employee_id: yup
      .string("Enter your Employee ID")
      .required("Employee ID is required"),
    first_name: yup.string().required("Enter First Name"),
    last_name: yup.string().required("Enter Last Name"),
    primary_email_id: yup
      .string()
      .email("Enter a valid email address")
      .required("Enter Primary EmailId"),
    secondary_email_id: yup.string().email("Enter a valid email address"),
    primary_mobile_no: yup
      .number()
      .typeError("Primary Mobile Number must be a number")
      .required("Enter Primary Mobile Number"),
    secondary_mobile_no: yup
      .number()
      .typeError("Secondary Mobile Number must be a number"),
    roles: yup.object().shape({
      role_id: yup.string("Enter your Role ID").required("Role ID is required"),
      role_name: yup.string("Enter your Role name").required("Role name is required"),
    }),
    password: yup.string().required("Enter password"),
    address: yup.object().shape({
      address: yup.string().required("Enter Address"),
      location: yup.string().required("Enter Location"),
      area: yup.string().required("Enter Area"),
      district: yup.string().required("Enter District"),
      taluka: yup.string().required("Enter Taluka"),
      state: yup.string().required("Enter State"),
      city: yup.string().required("Enter City"),
      country: yup.string(),
      pincode: yup.string().required("Enter Pincode"),
    }),
    kyc: yup.object().shape({
      pan_card_detail: yup.object().shape({
        pan_no: yup.string().required("Enter PAN Number"),
      }),
      aadhar_card_detail: yup.object().shape({
        aadhar_no: yup.string().required("Enter Aadhar Number"),
      }),
      bank_details: yup.object().shape({
        bank_name: yup.string().required("Enter Bank Name"),
        account_no: yup.string().required("Enter Account Number"),
        confirm_account_no: yup
          .string()
          .oneOf([yup.ref("account_no"), null], "Account Numbers must match"),
        ifsc_code: yup.string().required("Enter IFSC Code"),
      }),
    }),
    approvers: yup.object().shape({
      approver1: yup.object().shape({
        name: yup
          .string()
          .trim()
          .required("Approver 1 Name is required"),

        email_id: yup
          .string()
          .email("Invalid email format")
          .required("Approver 1 Email is required"),

        user_id: yup
          .string()
          .required("Approver 1 User ID is required"),

        employee_id: yup
          .string()
          .nullable() // If this field is optional
      }),
    })
  });

  // console.log(user)
  // useEffect
  useEffect(() => {
    dispatch(getRolesList());
    dispatch(getUsers({}));
  }, []);

  return (
    <>
      <Div sx={{ mt: "-4px" }}>
        <Heading Name={headingName} />
        <Box sx={{ marginTop: "2%" }}>
          <Formik
            initialValues={InitialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({
              values,
              setFieldValue,
              handleChange,
              isSubmitting,
              handleSubmit,
              touched,
              errors,
              handleBlur,
            }) => {
              console.log(errors)
              return (
                <>
                  <Form>
                    <Div>
                      <Div
                        sx={{
                          display: "flex",
                          width: "100%",
                          flexWrap: "wrap",
                          columnGap: 4,
                          gap: 3,
                          margin: "2% 0",
                        }}
                      >
                        <TextField
                          name="employee_id"
                          type="text"
                          value={values.employee_id}
                          label="Employee ID"
                          error={Boolean(errors?.employee_id && touched?.employee_id)}
                          helperText={
                            errors?.employee_id && touched?.employee_id
                              ? errors?.employee_id
                              : ""
                          }
                          size="small"
                          sx={{ width: "25%" }}
                          onChange={handleChange}
                        />
                        <TextField
                          name="first_name"
                          type="text"
                          value={values.first_name}
                          label="First Name"
                          size="small"
                          sx={{ width: "25%" }}
                          required
                          error={Boolean(errors?.first_name && touched?.first_name)}
                          helperText={
                            errors?.first_name && touched?.first_name
                              ? errors?.first_name
                              : ""
                          }
                          onChange={handleChange}
                        />
                        <TextField
                          name="last_name"
                          type="text"
                          value={values.last_name}
                          label="Last Name"
                          required
                          size="small"
                          sx={{ width: "25%" }}
                          error={Boolean(errors?.last_name && touched?.last_name)}
                          helperText={
                            errors?.last_name && touched?.last_name
                              ? errors?.last_name
                              : ""
                          }
                          onChange={handleChange}
                        />
                        <TextField
                          name="primary_email_id"
                          type="email"
                          value={values.primary_email_id}
                          label="Primary Email"
                          required
                          size="small"
                          sx={{ width: "25%" }}
                          error={
                            Boolean(errors?.primary_email_id &&
                              touched?.primary_email_id)
                          }
                          helperText={
                            errors?.primary_email_id &&
                              touched?.primary_email_id
                              ? errors?.primary_email_id
                              : ""
                          }
                          onChange={handleChange}
                        />
                        <TextField
                          name="secondary_email_id"
                          type="email"
                          value={values.secondary_email_id}
                          label="Secondary Email"
                          size="small"
                          sx={{ width: "25%" }}
                          error={
                            Boolean(errors?.secondary_email_id &&
                              touched?.secondary_email_id)
                          }
                          helperText={
                            errors?.secondary_email_id &&
                              touched?.secondary_email_id
                              ? errors?.secondary_email_id
                              : ""
                          }
                          onChange={handleChange}
                        />
                        <TextField
                          name="primary_mobile_no"
                          type="Number"
                          value={values.primary_mobile_no}
                          label="Primary Mobile"
                          size="small"
                          required
                          sx={{ width: "25%" }}
                          error={
                            Boolean(errors?.primary_mobile_no &&
                              touched?.primary_mobile_no)
                          }
                          helperText={
                            errors?.primary_mobile_no &&
                              touched?.primary_mobile_no
                              ? errors?.primary_mobile_no
                              : ""
                          }
                          onChange={handleChange}
                        />
                        <TextField
                          name="secondary_mobile_no"
                          type="Number"
                          value={values.secondary_mobile_no}
                          label="Secondary Mobile"
                          size="small"
                          sx={{ width: "25%" }}
                          error={
                            Boolean(errors?.secondary_mobile_no &&
                              touched?.secondary_mobile_no)
                          }
                          helperText={
                            errors?.secondary_mobile_no &&
                              touched?.secondary_mobile_no
                              ? errors?.secondary_mobile_no
                              : ""
                          }
                          onChange={handleChange}
                        />
                        <Div sx={{ width: "25%" }}>
                          <TextField
                            name="profile_pic"
                            type="file"
                            size="small"
                            sx={{ width: values?.profile_pic ? "80%" : "100%" }}
                            // value={values.profile_pic}
                            label="Profile Pic"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            // onChange={(e) => handleFileChange(e, "profile_pic")}
                            onChange={(e) =>
                              setFieldValue("profile_pic", e.target.files[0])
                            }
                            variant="outlined"
                          />
                          {values?.profile_pic && (
                            <Button
                              size="small"
                              sx={{ "&:hover": { bgcolor: "transparent" }, width: "20%" }}
                              onClick={() => {
                                handleImagesTab(values?.profile_pic);
                              }}
                            >
                              <PermMediaIcon sx={{ height: "100%" }} />
                            </Button>
                          )}
                        </Div>
                        {!state?.current_data?.password && (
                          <TextField
                            name="password"
                            type="text"
                            value={values.password}
                            label="Password"
                            size="small"
                            required
                            sx={{ width: "25%" }}
                            error={Boolean(errors?.password && touched?.password)}
                            helperText={
                              errors?.password && touched?.password
                                ? errors?.password
                                : ""
                            }
                            onChange={handleChange}
                          />
                        )}

                        <Autocomplete
                          freeSolo
                          key={values.roles?.role_id}
                          id={"roles"}
                          options={allroles || []}
                          size="small"
                          sx={{ width: "25%" }}
                          value={values.roles || null}
                          getOptionLabel={(option) => option?.role_name || ""}
                          isOptionEqualToValue={(option, value) => option?._id == value?.role_id}
                          onChange={(e, newValue) => {
                            setFieldValue("roles", {
                              role_id: newValue?._id,
                              role_name: newValue?.role_name,
                            });
                          }}
                          renderOption={(props, option) => (
                            <Box
                              component="li"
                              sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                              {...props}
                            >
                              {option?.role_name}
                            </Box>
                          )}
                          renderInput={(params) => (
                            <TextField {...params}
                              name="Roles"
                              label="Roles"
                              required
                              error={Boolean(errors?.roles?.role_name && touched?.roles?.role_name)}
                              helperText={
                                errors?.roles?.role_name && touched?.roles?.role_name
                                  ? errors?.roles?.role_name
                                  : ""
                              }
                            />
                          )}
                        />
                        {/* <FormControlLabel
                          control={<Switch onChange={handleChange} />}
                          value={values.isActive}
                          name="isActive"
                          label="Status"
                        /> */}
                      </Div>
                      {/* Bank Details */}

                      {/* Address */}
                      <Typography mt="1%" variant="h4">
                        Address
                      </Typography>
                      <Div
                        sx={{
                          // marginLeft: "2%",
                          display: "flex",
                          width: "100%",
                          flexWrap: "wrap",
                          columnGap: 2,
                        }}
                      >
                        <TextField
                          required
                          name="address.address"
                          label="Address"
                          size="small"
                          sx={{
                            width: "30%",
                            marginY: "10px",
                            "& .MuiInputBase-input": {
                              textTransform: "capitalize", // Capitalize first letter
                            },
                          }}
                          error={
                            Boolean(errors?.address?.address &&
                              touched?.address?.address)
                          }
                          helperText={
                            errors?.address?.address &&
                              touched?.address?.address
                              ? errors?.address?.address
                              : ""
                          }
                          onChange={handleChange}
                          value={values?.address?.address}
                          onBlur={handleBlur}
                        />
                        <AddressTypeDialog
                          type={"district"}
                          id={"address.district"}
                          name={"address.district"}
                          label={"District"}
                          list={district}
                          sx={{ width: "30%", marginY: "10px" }}
                          setFieldValue={setFieldValue}
                          value={values.address?.district}
                          error={
                            Boolean(errors?.address?.district &&
                              touched?.address?.district)
                          }
                          onBlur={handleBlur}
                          helperText={
                            errors?.address?.district &&
                              touched?.address?.district
                              ? errors?.address?.district
                              : ""
                          }
                        />
                        <AddressTypeDialog
                          type={"location"}
                          id={"address.location"}
                          name={"address.location"}
                          list={location}
                          sx={{ width: "30%", marginY: "10px" }}
                          label="Location"
                          setFieldValue={setFieldValue}
                          onBlur={handleBlur}
                          error={
                            Boolean(errors?.address?.location &&
                              touched?.address?.location)
                          }
                          helperText={
                            errors?.address?.location &&
                              touched?.address?.location
                              ? errors?.address?.location
                              : ""
                          }
                          onChange={handleChange}
                          value={values?.address?.location}
                        />
                        <AddressTypeDialog
                          type={"area"}
                          id={"address.area"}
                          name={"address.area"}
                          label={"Area"}
                          list={area}
                          sx={{ width: "30%", marginY: "10px" }}
                          setFieldValue={setFieldValue}
                          onBlur={handleBlur}
                          value={values.address?.area}
                          error={
                            Boolean(errors?.address?.area && touched?.address?.area)
                          }
                          helperText={
                            errors?.address?.area && touched?.address?.area
                              ? errors?.address?.area
                              : ""
                          }
                        />
                        <AddressTypeDialog
                          type={"taluka"}
                          id={"address.taluka"}
                          name={"address.taluka"}
                          label={"Taluka"}
                          list={taluka}
                          sx={{ width: "30%", marginY: "10px" }}
                          setFieldValue={setFieldValue}
                          onBlur={handleBlur}
                          value={values.address?.taluka}
                          error={
                            Boolean(errors?.address?.taluka && touched?.address?.taluka)
                          }
                          helperText={
                            errors?.address?.taluka && touched?.address?.taluka
                              ? errors?.address?.taluka
                              : ""
                          }
                        />

                        <Autocomplete
                          sx={{
                            width: "30%",
                            marginY: "10px",
                            textTransform: "capitalize",
                          }}
                          size="small"
                          id="state-autocomplete"
                          name="address.state"
                          options={stateCityList?.stateList || []}
                          value={values?.address?.state || null}
                          getOptionLabel={(option = "") => {
                            if (typeof option === "object") {
                              return option.name;
                            }
                            return option;
                          }}
                          isOptionEqualToValue={(option, value) =>
                            option?.name === value
                          }
                          freeSolo
                          autoHighlight
                          onBlur={handleBlur}
                          onChange={(e, newValue) => {
                            setFieldValue("address.state", newValue?.name);
                            if (newValue != null) {
                              const cityNames = City.getCitiesOfState(
                                "IN",
                                newValue.isoCode
                              );
                              setStateCityList({
                                ...stateCityList,
                                cityList: cityNames,
                              });
                            } else {
                              setStateCityList({
                                ...stateCityList,
                                cityList: City.getCitiesOfState("IN", "MH"),
                              });
                            }
                          }}
                          renderOption={(props, option) => (
                            <Box
                              component="li"
                              sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                              {...props}
                              key={option?.name}
                            >
                              {option?.name}
                            </Box>
                          )}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              name="address.state"
                              label="State"
                              required
                              error={
                                Boolean(errors?.address?.state &&
                                  touched?.address?.state)
                              }
                              helperText={
                                errors?.address?.state &&
                                  touched?.address?.state
                                  ? errors?.address?.state
                                  : ""
                              }
                            />
                          )}
                        />

                        <Autocomplete
                          sx={{ width: "30%", marginY: "10px" }}
                          size="small"
                          id="city-autocomplete"
                          options={stateCityList?.cityList || []}
                          label="city"
                          name="address.city"
                          value={values?.address?.city || null}
                          getOptionLabel={(option = "") => {
                            if (typeof option === "object") {
                              return option.name;
                            }
                            return option;
                          }}
                          isOptionEqualToValue={(option, value) =>
                            option?.name === value
                          }
                          freeSolo
                          autoHighlight
                          onBlur={handleBlur}
                          onChange={(e, newValue) => {
                            setFieldValue("address.city", newValue?.name);
                          }}
                          renderOption={(props, option) => (
                            <Box
                              component="li"
                              sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                              {...props}
                              key={option?.name}
                            >
                              {option?.name}
                            </Box>
                          )}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              name="city"
                              label="City"
                              required
                              error={
                                Boolean(errors?.address?.city && touched?.address?.city)
                              }
                              helperText={
                                errors?.address?.city && touched?.address?.city
                                  ? errors?.address?.city
                                  : ""
                              }
                            />
                          )}
                        />
                        {/* <TextField
                                    name="location"
                                    label="Location"
                                    size="small"
                                    sx={{ width: "30%", marginY: "10px" }}
                                    error={errors?.location && touched?.location}
                                    helperText={errors?.location && touched?.location ? errors?.location : ""}
                                    onChange={handleChange}
                                    value={values?.location}
                                    onBlur={handleBlur} />
                                <TextField
                                    name="area"
                                    label="Area"
                                    size="small"
                                    sx={{ width: "30%", marginY: "10px" }}
                                    error={errors?.area && touched?.area}
                                    helperText={errors?.area && touched?.area ? errors?.area : ""}
                                    onChange={handleChange}
                                    value={values?.area}
                                    onBlur={handleBlur} />
                                <TextField
                                    name="district"
                                    label="District"
                                    size="small"
                                    sx={{ width: "30%", marginY: "10px" }}
                                    error={errors?.district && touched?.district}
                                    helperText={errors?.district && touched?.district ? errors?.district : ""}
                                    onChange={handleChange}
                                    value={values?.district}
                                    onBlur={handleBlur} />
                                <TextField
                                    name="taluka"
                                    label="Taluka"
                                    size="small"
                                    sx={{ width: "30%", marginY: "10px" }}
                                    error={errors?.taluka && touched?.taluka}
                                    helperText={errors?.taluka && touched?.taluka ? errors?.taluka : ""}
                                    onChange={handleChange}
                                    value={values?.taluka}
                                    onBlur={handleBlur} /> */}
                        {/* <TextField
                                    required
                                    name="state"
                                    label="State"
                                    size="small"
                                    sx={{ width: "30%", marginY: "10px" }}
                                    error={errors?.state && touched?.state}
                                    helperText={errors?.state && touched?.state ? errors?.state : ""}
                                    onChange={handleChange}
                                    value={values?.state}
                                    onBlur={handleBlur} />
                                <TextField
                                    required
                                    name="city"
                                    label="City"
                                    size="small"
                                    sx={{ width: "30%", marginY: "10px" }}
                                    error={errors?.city && touched?.city}
                                    helperText={errors?.city && touched?.city ? errors?.city : ""}
                                    onChange={handleChange}
                                    value={values?.city}
                                    onBlur={handleBlur} />
                                <TextField
                                    required
                                    name="country"
                                    label="Country"
                                    size="small"
                                    sx={{ width: "30%", marginY: "10px" }}
                                    error={errors?.country && touched?.country}
                                    helperText={errors?.country && touched?.country ? errors?.country : ""}
                                    onChange={handleChange}
                                    value={values?.country}
                                    onBlur={handleBlur} /> */}
                        <TextField
                          required
                          name="address.pincode"
                          label="Pincode"
                          size="small"
                          sx={{ width: "30%", marginY: "10px" }}
                          error={
                            Boolean(errors?.address?.pincode &&
                              touched?.address?.pincode)
                          }
                          helperText={
                            errors?.address?.pincode &&
                              touched?.address?.pincode
                              ? errors?.address?.pincode
                              : ""
                          }
                          onChange={handleChange}
                          value={values?.address?.pincode}
                          onBlur={handleBlur}
                        />
                      </Div>
                      <Div>
                        <Typography variant="h1">Bank Details</Typography>
                        <Div
                          sx={{
                            display: "flex",
                            width: "100%",
                            flexWrap: "wrap",
                            columnGap: 4,
                            gap: 3,
                            margin: "1% 0",
                          }}
                        >
                          <TextField
                            name="kyc.bank_details.bank_name"
                            type="text"
                            value={values.kyc.bank_details.bank_name}
                            label="Bank Name"
                            size="small"
                            sx={{ width: "25%" }}
                            error={
                              Boolean(errors?.kyc?.bank_details?.bank_name &&
                                touched?.kyc?.bank_details?.bank_name)
                            }
                            helperText={
                              errors?.kyc?.bank_details?.bank_name &&
                                touched?.kyc?.bank_details?.bank_name
                                ? errors?.kyc?.bank_details?.bank_name
                                : ""
                            }
                            onChange={handleChange}
                          />
                          <TextField
                            name="kyc.bank_details.account_no"
                            type="number"
                            value={values.kyc.bank_details.account_no}
                            label="Account Number"
                            size="small"
                            sx={{ width: "25%" }}
                            error={
                              Boolean(errors?.kyc?.bank_details?.account_no &&
                                touched?.kyc?.bank_details?.account_no)
                            }
                            helperText={
                              errors?.kyc?.bank_details?.account_no &&
                                touched?.kyc?.bank_details?.account_no
                                ? errors?.kyc?.bank_details?.account_no
                                : ""
                            }
                            onChange={handleChange}
                          />
                          <TextField
                            name="kyc.bank_details.confirm_account_no"
                            type="number"
                            value={values.kyc.bank_details.confirm_account_no}
                            label="Confirm Account Number"
                            size="small"
                            sx={{ width: "25%" }}
                            error={
                              Boolean(errors?.kyc?.bank_details?.confirm_account_no &&
                                touched?.kyc?.bank_details?.confirm_account_no)
                            }
                            helperText={
                              errors?.kyc?.bank_details?.confirm_account_no &&
                                touched?.kyc?.bank_details?.confirm_account_no
                                ? errors?.kyc?.bank_details?.confirm_account_no
                                : ""
                            }
                            onChange={handleChange}
                          />
                          <TextField
                            name="kyc.bank_details.ifsc_code"
                            type="text"
                            value={values.kyc.bank_details.ifsc_code}
                            label="IFSC"
                            size="small"
                            sx={{ width: "25%" }}
                            error={
                              Boolean(errors?.kyc?.bank_details?.ifsc_code &&
                                touched?.kyc?.bank_details?.ifsc_code)
                            }
                            helperText={
                              errors?.kyc?.bank_details?.ifsc_code &&
                                touched?.kyc?.bank_details?.ifsc_code
                                ? errors?.kyc?.bank_details?.ifsc_code
                                : ""
                            }
                            onChange={handleChange}
                          />
                          <Div sx={{ width: "25%" }}>
                            <TextField
                              name="kyc.bank_details.passbook_image"
                              type="file"
                              // value={values.kyc.bank_details.passbook_image}
                              size="small"
                              sx={{ width: values?.kyc?.bank_details?.passbook_image ? "80%" : "100%" }}
                              label="Passbook Image"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              error={
                                Boolean(errors?.kyc?.bank_details?.passbook_image &&
                                  touched?.kyc?.bank_details?.passbook_image)
                              }
                              helperText={
                                errors?.kyc?.bank_details?.passbook_image &&
                                  touched?.kyc?.bank_details?.passbook_image
                                  ? errors?.kyc?.bank_details?.passbook_image
                                  : ""
                              }
                              onChange={(e) =>
                                setFieldValue(
                                  "kyc.bank_details.passbook_image",
                                  e.target.files[0]
                                )
                              }
                            />
                            {values?.kyc?.bank_details?.passbook_image && (
                              <Button
                                sx={{ "&:hover": { bgcolor: "transparent" } }}
                                onClick={() => {
                                  handleImagesTab(
                                    values?.kyc?.bank_details?.passbook_image
                                  );
                                }}
                              >
                                <PermMediaIcon sx={{ height: "100%" }} />
                              </Button>
                            )}
                          </Div>
                        </Div>
                        <Typography variant="h1">KYC Details</Typography>
                        <Div
                          sx={{
                            display: "flex",
                            width: "100%",
                            flexWrap: "wrap",
                            columnGap: 4,
                            gap: 3,
                            margin: "1% 0",
                          }}
                        >
                          <TextField
                            name="kyc.pan_card_detail.pan_no"
                            type="text"
                            value={values.kyc.pan_card_detail.pan_no}
                            label="Pan Number"
                            size="small"
                            sx={{ width: "25%" }}
                            error={
                              Boolean(errors?.kyc?.pan_card_detail?.pan_no &&
                                touched?.kyc?.pan_card_detail?.pan_no)
                            }
                            helperText={
                              errors?.kyc?.pan_card_detail?.pan_no &&
                                touched?.kyc?.pan_card_detail?.pan_no
                                ? errors?.kyc?.pan_card_detail?.pan_no
                                : ""
                            }
                            onChange={handleChange}
                          />
                          <Div sx={{ width: "25%" }}>
                            <TextField
                              name="kyc.pan_card_detail.pan_image"
                              type="file"
                              // value={values.kyc.pan_card_detail.pan_image}
                              size="small"
                              sx={{ width: values?.kyc?.pan_card_detail?.pan_image ? "80%" : "100%" }}
                              label="Pan Card Image"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              onChange={(e) =>
                                setFieldValue(
                                  "kyc.pan_card_detail.pan_image",
                                  e.target.files[0]
                                )
                              }
                            />
                            {values?.kyc?.pan_card_detail?.pan_image && (
                              <Button
                                sx={{
                                  "&:hover": { bgcolor: "transparent" },
                                  width: "20%",
                                }}
                                onClick={() => {
                                  handleImagesTab(
                                    values?.kyc?.pan_card_detail?.pan_image
                                  );
                                }}
                              >
                                <PermMediaIcon sx={{ height: "100%" }} />
                              </Button>
                            )}
                          </Div>
                          <TextField
                            name="kyc.aadhar_card_detail.aadhar_no"
                            type="number"
                            value={values.kyc.aadhar_card_detail.aadhar_no}
                            label="Aadhar Number"
                            size="small"
                            sx={{ width: "25%" }}
                            error={
                              Boolean(errors?.kyc?.aadhar_card_detail?.aadhar_no &&
                                touched?.kyc?.aadhar_card_detail?.aadhar_no)
                            }
                            helperText={
                              errors?.kyc?.aadhar_card_detail?.aadhar_no &&
                                touched?.kyc?.aadhar_card_detail?.aadhar_no
                                ? errors?.kyc?.aadhar_card_detail?.aadhar_no
                                : ""
                            }
                            onChange={handleChange}
                          />
                          <Div sx={{ width: "25%" }}>
                            {/* <FormControlLabel label="Aadhar Image" /> */}
                            <TextField
                              name="kyc.aadhar_card_detail.aadhar_image"
                              type="file"
                              // value={values.kyc.aadhar_card_detail.aadhar_image}
                              size="small"
                              sx={{ width: values?.kyc?.aadhar_card_detail?.aadhar_image ? "80%" : "100%" }}
                              label="Aadhar Card Image"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              onChange={(e) =>
                                setFieldValue(
                                  "kyc.aadhar_card_detail.aadhar_image",
                                  e.target.files[0]
                                )
                              }
                            />
                            {values?.kyc?.aadhar_card_detail?.aadhar_image && (
                              <Button
                                sx={{
                                  "&:hover": { bgcolor: "transparent" },
                                  width: "20%",
                                }}
                                onClick={() => {
                                  handleImagesTab(
                                    values?.kyc?.aadhar_card_detail?.aadhar_image
                                  );
                                }}
                              >
                                <PermMediaIcon sx={{ height: "100%" }} />
                              </Button>
                            )}
                          </Div>
                        </Div>
                      </Div>
                      <Typography variant="h1">Approvers</Typography>
                      <Div
                        sx={{
                          display: "flex",
                          width: "100%",
                          flexWrap: "wrap",
                          columnGap: 4,
                          gap: 3,
                          margin: "1% 0",
                        }}
                      >
                        <Autocomplete
                          // disablePortal
                          id={"approver1"}
                          options={user}
                          size="small"
                          sx={{ width: 300 }}
                          value={
                            user?.filter(
                              (item) =>
                                item?._id ==
                                values?.approvers?.approver1?.user_id
                            )?.[0]?.current_data?.first_name || null
                          }
                          onChange={(e, newValue) => {
                            setFieldValue("approvers.approver1", {
                              name: newValue?.current_data?.first_name,
                              email_id:
                                newValue?.current_data?.primary_email_id,
                              user_id: newValue?._id,
                              employee_id: newValue?.current_data?.employee_id,
                            });
                          }}
                          renderOption={(props, option) => (
                            <Box
                              component="li"
                              sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                              {...props}
                            >
                              {option?.current_data?.first_name}
                            </Box>
                          )}
                          renderInput={(params) => (
                            <TextField {...params} label="Approver 1"
                              error={
                                Boolean(errors?.approvers?.approver1?.user_id &&
                                  touched?.approvers?.approver1?.user_id)
                              }
                              helperText={
                                errors?.approvers?.approver1?.user_id &&
                                  touched?.approvers?.approver1?.user_id
                                  ? errors?.approvers?.approver1?.user_id
                                  : ""
                              }
                            />
                          )}
                        />

                        <Autocomplete
                          // disablePortal
                          id={"approver2"}
                          options={user}
                          size="small"
                          sx={{ width: 300 }}
                          value={
                            user?.filter(
                              (item) =>
                                item?._id ==
                                values?.approvers?.approver2?.user_id
                            )?.[0]?.current_data?.first_name || null
                          }
                          onChange={(e, newValue) => {
                            setFieldValue("approvers.approver2", {
                              name: newValue?.current_data?.first_name,
                              email_id:
                                newValue?.current_data?.primary_email_id,
                              user_id: newValue?._id,
                              employee_id: newValue?.current_data?.employee_id,
                            });
                          }}
                          renderOption={(props, option) => (
                            <Box
                              component="li"
                              sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                              {...props}
                            >
                              {option?.current_data?.first_name}
                            </Box>
                          )}
                          renderInput={(params) => (
                            <TextField {...params} label="Approver 2" />
                          )}
                        />
                      </Div>
                      <Div
                        sx={{
                          display: "flex",
                          width: "100%",
                          flexWrap: "wrap",
                          columnGap: 4,
                          gap: 2,
                          margin: "2% 0",
                        }}
                      >
                        <Button
                          sx={{ width: "100px" }}
                          variant="contained"
                          onClick={() => navigate("/dashboards/users")}
                        >
                          Back
                        </Button>
                        <Button
                          type="submit"
                          onClick={handleSubmit}
                          variant="contained"
                        >
                          Submit
                        </Button>
                      </Div>
                    </Div>
                  </Form>
                </>
              );
            }}
          </Formik>
        </Box>
      </Div>
    </>
  );
};

export default AddEditUsers;
